import React from "react";
import { RootComponentListPageInitialState, PageNewState } from ".";

export const RootComponentListPageContext = React.createContext({
  pageState: RootComponentListPageInitialState,
  setPageState: (pageState: PageNewState) => {},
});
